// @spec SCF-004

import { useTranslation } from 'react-i18next';

export function RoutePending() {
  const { t } = useTranslation('common');
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-background/80 backdrop-blur-sm">
      <div className="flex flex-col items-center gap-2">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
        <span className="sr-only">{t('shell.loading')}</span>
      </div>
    </div>
  );
}
